import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';
import { queryKeys } from '@/lib/query-keys';

async function fetchUserRoles(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from('user_system_roles')
    .select('system_roles(name)')
    .eq('user_id', userId);

  if (error) throw error;

  return (data || []).map((row: any) => row.system_roles?.name).filter(Boolean);
}

export function useSuperAdmin() {
  const { user } = useAuth();

  const { data: roles = [], isPending: isLoading } = useQuery({
    queryKey: queryKeys.systemRoles.userRoles(user?.id || ''),
    queryFn: () => fetchUserRoles(user!.id),
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    isSuperAdmin: roles.includes('super_admin'),
    isLoading,
  };
}
